import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
export function LoadingSpinner({ size = 'md', className }) {
    const sizeClasses = {
        sm: 'h-4 w-4 border-2',
        md: 'h-6 w-6 border-2',
        lg: 'h-10 w-10 border-4',
    };
    return (_jsx("span", { className: cn('inline-block animate-spin rounded-full border-wine-200 border-t-wine-700', sizeClasses[size], className), role: "status", "aria-label": "Loading" }));
}
export function PageLoader() {
    return (_jsx("div", { className: "flex h-64 items-center justify-center", children: _jsx(LoadingSpinner, { size: "lg" }) }));
}
